<template>
    <span>
    <div class="static-heaer background">

        <div class="item-header2" >
           <div class="b-title">Contenido General</div>
            <ul style="font-size: 1.1rem">
                <li>¿Qué es la comunicación? </li>
                 <li>¿Qué es la comunicación efectiva y asertiva? </li>
                 <li>Importancia del lenguaje y el pensamiento de pacientes / profesionales</li>
                <li>¿Cómo obtener información del lenguaje oral y corporal del paciente/usuario, en telemedicina?
                </li>
                <li>
                    Importancia del lenguaje oral y corporal del profesional de la salud en telemedicina.
                </li>
            </ul>
        </div>
        <div class="item-header">
            <div class="b-title" data-aos="flip-right"></div>
            <ul style="font-size: 1.1rem">
                <li>Comunicación en la prevención de problemas éticos y legales en telemedicina </li>
                 <li>Presentaciones efectivas </li>
                 <li>Manejo de la cámara y la voz en Telemedicina</li>
                <li>Presentando un mensaje con lenguaje según la audiencia.
                </li>
                <li>
                    Los canales sensoriales e intercambio emocional a través de la pantalla
                </li>
                <li>
                    Sesiones asincrónicas con asignaciones y tareas viernes y sábado
                </li>
                <li>
                    Incluye certificado de asistencia a los que cumplen 75% del contenido
                </li>
            </ul>
         <div style="display: flex; justify-content: center; text-align: center; flex-direction: column; align-items: center; z-index: 2">
<h2 style="font-weight: bold; color: white">INVERSIÓN: 137$</h2>
                <a href="https://cambiandotusalud.com/checkout/137/a79cd41a617c3901f4e9759b99cee2935d674e080650e253f1d8f598b0bddc35" target="_blank" style="width: 230px; height: 80px; background-color: #FF4500; border: solid 1px white; border-radius: 10px; color: white; font-weight: 700; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 1.5rem">INSCRIBETE ÁQUI!</a>
            </div>

        </div>
        <span v-if="modal === true">
            <transition name="modal">
                <div class="modal-mask">
                  <div class="modal-wrapper">
                    <div class="modal-container">

                      <div class="modal-body">
                        <form-landing :data_landing="data_landing"></form-landing>
                      </div>

                      <div class="modal-footer">
                        <slot name="footer">
                          <button class="modal-default-button" @click="modal = false">
                            CANCELAR
                          </button>
                        </slot>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
        </span>
    </div>

    </span>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import formLanding from './../resources/formLandingEvent.vue'
    export default {
        name: '',
        components: {
            formLanding
        },
        created(){

        },
        data(){
            return {
                showModal: false,
                modal: false,
                postRegister:false,
                description:true,
                data_landing:{
                    urlRoom:'#1 ingresa al canal de TELEGRAM, EL ABC DE LA TELEMEDICINA y alli te daremos los demás pasos a seguir....nos vemos en telegram!',
                    id_room:'https://t.me/ABCdelatelemedicina',
                    date:'Del 6 y 10 de Julio - Hora 7:00 PM MX - CO - EC / 8:00PM Hora PM Miami - Venezuela',
                    title: 'El ABC de la Telemedicina',
                    tag:'ABC-Telemedicina',
                    type:'2',
                    url_download:''
                }
            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style scoped>
    p{
        font-size: 1.4rem;
        font-weight: 800;
        color: yellow;
    }
    .background{
        background: rgb(121,9,81);
        background: linear-gradient(90deg, rgba(121,9,81,1) 0%, rgba(255,59,0,1) 100%);
    }
    li{
        font-size: 1.3rem;
    }
    .static-heaer{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 70vh;
        background-size: cover;
        background-repeat: no-repeat;
        overflow-x : hidden;
        overflow-y : hidden
    }
    .video{
        width: 100%;
        height: 100%;

    }
    .item-header{
        width: 55%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: white;
    }
    .item-header2{
       width: 55%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        text-shadow: 2px 2px 2px #0F4F84;
        padding: 20px 20px;
        color: white;
    }
    .b-title{
        font-size: 4rem;
        line-height: 5rem;
        font-weight: 800;
        text-align: center;
        font-family: 'Gayathri', sans-serif;
    }
    .b-title2{
        font-size: 3rem;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }


    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-containerx {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 600px;
        background-color: transparent;
        border-radius: 2px;
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 0 0;
    }

    .modal-default-button {
        float: right;
    }


    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    @media (min-width: 1281px) {

    }

    @media (min-width: 1025px) and (max-width: 1280px) {

    }
    @media (min-width: 768px) and (max-width: 1024px) {

    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {

    }

    @media (min-width: 481px) and (max-width: 767px) {
        .static-heaer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
        }
        .item-header{
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;

        }
        .item-header2{
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;

        }
        .video{
            width: 95%;
            height: 200px;

        }
    }

    @media (min-width: 120px) and (max-width: 480px) {
        .static-heaer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
        }
        .item-header{
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;

        }
        .item-header2{
            width: 100%;
           margin-top: 20px;
            margin-bottom: 20px;

        }
        .video{
            width: 95%;
            height: 200px;

        }
    }
</style>